import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { stockRealInventoryService, IOccupyFidles, IOccupyDetails } from "../realInventoryStatisticService"
import useGlobalModel from "@/model/globalModel";
import { formatNum, transPgToPagination } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useStockRealInventoryModel } from "../realInventoryStatisticModel";
interface IOccupyStocType {
    visible: boolean,
    onCancel: () => void,
    materialCode: string
}
export const OccupyStockModel = ({
    visible,
    materialCode,
    onCancel,
}: IOccupyStocType) => {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const { getTreeNodeName } = useDictModel();
    const [searchParam, setSearchParam] = useState<IOccupyFidles>({})
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [dataSource, setDataSource] = useState<IOccupyDetails[]>([]);
    const { loading, setLoading } = useStockRealInventoryModel();

    useEffect(() => {
        if (visible) {
            loadData(initPgCfg, { materialCode })
            setSearchParam({ materialCode })
        }
    }, [visible])
    const loadData = async (page?: ISearchPage, searchValue: IOccupyFidles = searchParam) => {
        setLoading(true)
        let searchParams = {
            ...searchValue,
            shopId: shopAndOrg.shopId,
            // ...shopAndOrg,
            // ...sourceAppOrBranch,
            // pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            // pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            types: ["occupy_vam", "occupy_vmm", "occupy_ssd", "occupy_prd"],
        }
        let { retData } = await stockRealInventoryService.occupy(searchParams)
        //     let { records, ...pg } = retData
        //    setPgCfg(transPgToPagination(pg));
        //     setDataSource(records);
        setLoading(false);
        setDataSource(retData);
    }
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        },
        // {
        //     title: '单据编号',
        //     width: 120,
        //     dataIndex: 'code',
        // }, {
        //     title: '单据类型',
        //     width: 120,
        //     dataIndex: 'type',
        // }, {
        //     title: '单据状态',
        //     width: 120,
        //     dataIndex: 'status',
        //     render: (text) => getTreeNodeName(text)
        // }, {
        //     title: '占用数量',
        //     width: 120,
        //     dataIndex: 'num',
        // }, {
        //     title: '客户名称',
        //     width: 120,
        //     dataIndex: 'customerName',
        // }
        {
            title: '业务日期',
            width: 180,
            align: "center",
            dataIndex: 'createTime',
        }, {
            title: '单据编号',
            width: 120,
            align: "center",
            dataIndex: 'code',
        }, {
            title: '仓库',
            width: 120,
            align: "center",
            dataIndex: 'warehouseName',
        },
        {
            title: '单价',
            width: 160,
            align: "center",
            dataIndex: 'price',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '数量',
            width: 140,
            align: "center",
            dataIndex: 'num',
        }, {
            title: '金额',
            width: 120,
            align: "center",
            render: (text, record) => `￥${formatNum(record.num * record.price)}`
        },
    ]
    return <YHModal
        visible={visible}
        onCancel={onCancel}
        title="占用明细查看"
        width={'70%'}
        bodyHeight={730}
        showFooter={false}
    >
        <YhBox title={""}>
            <Table
                bordered
                loading={loading}
                style={{ cursor: "pointer" }}
                columns={columns}
                dataSource={dataSource}
                // pagination={{
                //     ...pgCfg,
                //     position: ["bottomCenter"],
                //showTotal: () => `共${pgCfg.total}条`,
                // onChange: (pageNum, pageSize) => {
                //     loadData({ pageNum, pageSize }).then();
                // }
                // }}
                scroll={{ x: 'max-content', y: 520 }}
            >
            </Table>
        </YhBox>

    </YHModal>
}